<template>
  <div id="app">
    <router-view  />
  </div>
</template>

<script>
// import mqtt from "mqtt";
// import store from "./store/index"
export default {
name:"app",
  mounted(){
    //初始化显示MQTT主题
//  this.mqttConnect()
  },
  methods:{
  
    //申明MQTT方法
    // mqttConnect() {
    //             var client = mqtt.connect("mqtt://local.vrmaker.vip:8083/mqtt", {
    //                 username: "vrmaker",
    //                 password: "vrmaker",
    //             });
    //         //链接成功返回值
    //             client.on("connect", () => {
    //                 console.log("Mqtt connected ...");
    //                 // 总负荷
    //                 client.subscribe([
    //                     "VrMaker/LCY/+/PUBLISH/+/+/+",
                       
    //                     // "VrMaker/LCY/+/PUBLISH/+/+/+/#",
    //                 ]);
    //             });
    //         //接收消息                //主题 //返回消息
    //             client.on("message", (topic, message) => {

    //                 let keys = topic.split('/')
    //                 let len = keys.length
    //                 let topicName = keys[len - 3] + '/' + keys[len - 2] + '/' + keys[len - 1]

    //                 console.log(topicName, Number(message));

    //                 // this.$store.commit("addMQTTData", {
    //                 //     key: topicName,
    //                 //     val: message,
    //                 // });
    //             });

    //             client.on("error", (err) => {
    //                 console.log("mqtt error !!!", err);
    //                 client.end();
    //             });

    //             client.on("close", () => {
    //                 console.log("mqtt closed!");
    //             });
    //         },
  }
};
</script>
<style lang="less">
@import "assets/css/all.less";
@import "assets/css/func.less";
@import "./assets/fonts/font.css";
</style>


